import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from '../NavDrawer.styled';
import { RouteConfig } from 'react-router-config';
import Item from './Item';
import CookieStatementIcon from '@mui/icons-material/CookieOutlined';

type CookieStatementButtonProps = {
  onClick: (buttonName: string) => void;
  route?: RouteConfig;
};

const CookieStatementButton: FC<CookieStatementButtonProps> = ({ onClick, route }) => {
  const { t } = useTranslation();

  const openRoute = () => {
    onClick(route?.name);
  };

  if (!route) {
    return null;
  }

  return (
    <NavLink to={route.path as string} key={route.name}>
      <Item
        icon={<CookieStatementIcon fontSize="inherit" />}
        menuName={t(`general.header.menu.${route.name}`)}
        handleClick={openRoute}
      />
    </NavLink>
  );
};

export default CookieStatementButton;
